import React, { useEffect, useRef } from 'react';
import dayjs from "dayjs"
import style from "../styles/chat.module.sass"
import { Message, MessageBoxProps } from '../interfaces/interfaces';
import { useChat } from '../contexts/ChatContext';
import { MessageItem } from './MessageItem';
import { MessageForm } from './MessageForm';

export default function MessageBox(props: MessageBoxProps) {
    const { activeRoom, activeBox, messages, setMessages } = props;
    const { user, roomSocket: socket } = useChat()

    const messageBoxRef = useRef<HTMLDivElement | null>(null);

    // Function to scroll to the bottom of the message box
    const scrollToUnread = () => {
        if (messageBoxRef.current) {
            const unreadMessage = messageBoxRef.current.querySelector(`.${style.unread_message_box}`) as HTMLElement;
            console.log('unreadMessage', unreadMessage)
            if (unreadMessage) {
                const scrollPosition = unreadMessage.offsetTop + unreadMessage.clientHeight - messageBoxRef.current.clientHeight;
                messageBoxRef.current.scrollTop = scrollPosition - 10;
            } else {
                // If no unread messages, scroll to the bottom
                messageBoxRef.current.scrollTop = messageBoxRef.current.scrollHeight;
            }
        }
    };



    const handleMarkAsRead = (elem: HTMLDivElement) => {

        const data = {
            event_type: 'mark_as_read',
            message_id: elem.dataset.id,
            room: activeRoom,
        };

        socket && socket.send(JSON.stringify(data));
        elem.classList.remove(style.unread_message_box);
    };

    const handleReadMessages = () => {
        if (messageBoxRef.current) {
            const messageBox = messageBoxRef.current;
            const unreadMessages = messageBox.querySelectorAll(`.${style.unread_message_box}`);
            // console.log('unreadMessages', unreadMessages)
            const chatItemsArray = Array.from(unreadMessages);

            chatItemsArray.forEach((item) => {
                console.log('item', item)
                if (isElementInMessageBoxViewport(item, messageBox)) {
                    handleMarkAsRead(item as HTMLDivElement);
                }
            });

            messageBoxRef.current.addEventListener('scroll', () => {
                chatItemsArray.forEach((item) => {
                    if (isElementInMessageBoxViewport(item, messageBox)) {
                        handleMarkAsRead(item as HTMLDivElement);
                    }
                });
            });
        }
    };

    const isElementInMessageBoxViewport = (element: Element, messageBox: Element) => {
        const boxRect = messageBox.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        return elementRect.top >= boxRect.top && elementRect.bottom <= boxRect.bottom;
    };

    useEffect(() => {
        scrollToUnread();
        handleReadMessages();
    }, [messages]);


    function groupByDate(messages: Message[]): Record<string, Message[]> {
        return messages.reduce((groups, message) => {
            const date = message.date_create && message.date_create.split('T')[0] || "";
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(message);
            return groups;
        }, {} as Record<string, Message[]>);
    }

    const groupedMessages = groupByDate(messages);

    // console.log('messages', messages)
    return (
        <>
            {user &&
                <>
                    <div
                        ref={messageBoxRef}
                        className={activeBox ? `${style.message_box} ${style.active}` : style.message_box}>



                        {messages &&
                            Object.keys(groupedMessages).map(date => (
                                <div key={date}>
                                    <div className={style.date_group}>
                                        <p className={style.date_group_value} >
                                            {dayjs(date).format("DD/MM/YYYY")}
                                        </p>
                                    </div>
                                    {groupedMessages[date].map((item, index, arr) => {
                                        const prevItem = arr[index - 1];
                                        const showTime = !prevItem || dayjs(item.date_create).format("HH:mm") !== dayjs(prevItem.date_create).format("HH:mm");

                                        return (
                                            <MessageItem
                                                messages={messages}
                                                setMessages={setMessages}
                                                room={activeRoom}
                                                message={item}
                                                key={"message-" + item.id}
                                                user={user}
                                                showTime={showTime}   // This is the new prop
                                            />
                                        );
                                    })}
                                </div>
                            ))}

                    </div>

                    <MessageForm user={user} {...props} />
                </>

            }
        </>
    );
}

